import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { surveyApi } from '../../api/surveyApi';
import { isCopanySuperOrSubAdmin, isSuperAndSubAdmin } from '../../utils/helper';
import DonutChartCard from '../../component/common/cards/DonutChartCard';
import { useLocation } from 'react-router-dom';
import { DashboardContent } from '../../utils/pageContent';

const DashboardSurveyCard = () => {
  const [resultData, setResultData] = useState();
  const location = useLocation();
  const company = location.state;
const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
const SurveyCardData = DashboardContent.surveyCardContent;
  useEffect(() => {
    fetchSurveyStatus();
  }, []);

  const fetchSurveyStatus = async () => {
    if (isCopanySuperOrSubAdmin()) {
      try {
        await surveyApi
          .getSurveyStatus(false, companyId)
          .then((response) => {
            setResultData(response?.data?.data);
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else if (isSuperAndSubAdmin()) {
      try {
        await surveyApi
          .getSurveyStatus(true, company?._id)
          .then((response) => {
            setResultData(response?.data?.data);
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const OverAllResponseData = [
    {
      label: SurveyCardData.overallResponses.responses,
      value:
        resultData?.completedSurveys + resultData?.openSurveys
          ? resultData?.completedSurveys + resultData?.openSurveys
          : 0,
      percentage:
        resultData?.completedSurveys + resultData?.openSurveys === 'NaN'
          ? 0
          : resultData?.completedSurveys + resultData?.openSurveys || 0,
      color: '#F05289'
    },
    {
      label: SurveyCardData.overallResponses.noResponse,
      value: resultData?.notAttemptedSurveys ? resultData?.notAttemptedSurveys : 0,
      percentage:
        resultData?.notAttemptedSurveys == 'NaN' ? 0 : resultData?.notAttemptedSurveys || 0,
      color: '#FF9BCB'
    }
  ];

  const optionsD = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      }
    },
    cutout: '90%',
    radius: '70%'
  };
  const ProgressBar = ({ label, percentage }) => (
    <div className="mb-4">
      {!!label && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-lg font-normal">{label}</span>
          <span className="text-sm text-[#67A14A]">{percentage}%</span>
        </div>
      )}
      <div className="w-full bg-[#C2EC97] rounded-full h-2">
        <div className="bg-[#67A14A] h-2 rounded-full" style={{ width: `${percentage}%` }}></div>
      </div>
    </div>
  );
  return (
    <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 dark:bg-shoorah-darkBgTabColor dark:border-none dark:text-shoorah-darkBg bg-white">
      <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
        {SurveyCardData.title}
      </div>
      <div className="text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-[400]">
        {SurveyCardData.description}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 2xl:gap-6 md:mt-6 mt-4 sm:w-full overflow-x-auto horizontal-card-scrollbar md:pb-4">
        <div className="min-h-[200px] sm:min-h-full sm:w-[187px] 2xl:w-full sm:max-w-[300px] md:p-6 p-4 flex flex-col justify-between min-w-[187px] bg-[#FFFFFF] rounded-2xl border border-[#E7E8EA] dark:bg-shoorah-darkBgColor dark:border-none">
          <div className="text-xl font-medium leading-[22px] text-shoorah-textBlack">
            {SurveyCardData.totalCreatedSurveys}
          </div>
          <div className="lg:text-[64px] text-[48px] lg:leading-[80px] leading-[60px] font-semibold text-shoorah-textBlack">
            {resultData?.totalSurveys ? resultData?.totalSurveys : 0}
          </div>
        </div>
        <div className="flex flex-col md:gap-[27px] gap-4 w-full sm:min-w-[333px]">
          <div className="md:px-5 md:py-6 p-4 dark:bg-shoorah-darkBgColor dark:border-none border border-[#E7E8EA] rounded-xl h-[175px] bg-shoorah-white">
            <div className="text-xl font-medium leading-[22px] text-shoorah-textBlack mb-[22px]">
              {SurveyCardData.averageCompletionTime.title}
            </div>
            <div className="text-[48px] leading-[36px] font-semibold text-shoorah-textBlack mb-[18px]">
              {SurveyCardData.averageCompletionTime.zero} <span className="text-[30px] leading-[36px] font-semibold italic">{SurveyCardData.averageCompletionTime.minutes}</span>
            </div>
            <div className="flex items-center justify-between w-full">
              <div className="text-xs leading-5 text-[#8FD460]">{SurveyCardData.averageCompletionTime.text1}</div>
              <div className="text-[rgba(41,45,50,0.38)] text-xs leading-5">{SurveyCardData.averageCompletionTime.text2}</div>
            </div>
          </div>
          <div className="md:px-5 md:py-6 p-4 bg-[#ffffff] dark:bg-shoorah-darkBgColor dark:border-none border border-[#E7E8EA] rounded-xl">
            <div className="flex items-center justify-between mb-[30px]">
              <div className="text-xl leading-[22px] font-medium text-shoorah-textBlack">
                {SurveyCardData.completionRate.title}
              </div>
              <div className="text-[18px] leading-[21px] font-medium text-[#67A14A]">
                {resultData?.completionRate ? resultData?.completionRate : SurveyCardData.completionRate.zero}
              </div>
            </div>
            <div>
              <ProgressBar
                percentage={
                  resultData?.completionRate?.split('%')[0]
                    ? resultData?.completionRate?.split('%')[0]
                    : 0
                }
              />
            </div>
          </div>
        </div>
        <div className="w-full lg:max-w-[264px] 2xl:max-w-[300px]">
          <DonutChartCard
            data={OverAllResponseData}
            title={SurveyCardData.overallResponses.title}
            hidePercentage
            labelClassName={'w-full'}
            className={
              'dark:!bg-shoorah-darkBgColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardSurveyCard;
